export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg
        viewBox="0 0 32 32"
        className={className}
        role="img"
        aria-label="Scalehaus logo"
    >
        <rect width="32" height="32" rx="3" fill="#0A0A0A" />
        <path
            d="M5 14.5 16 4.5l11 10"
            fill="none"
            stroke="#C6A87C"
            strokeWidth="2.4"
            strokeLinecap="square"
            strokeLinejoin="miter"
        />
        <rect x="8" y="20" width="3.4" height="6.2" fill="#C6A87C" />
        <rect x="14.3" y="17.4" width="3.4" height="8.8" fill="#A68A60" />
        <rect x="20.6" y="14.8" width="3.4" height="11.4" fill="#C6A87C" />
    </svg>
);

export const Logo = ({ onClick }) => (
    <a
        href="#top"
        onClick={onClick}
        data-testid="logo-home-link"
        className="flex items-center gap-3 group"
        aria-label="Scalehaus, back to top"
    >
        <LogoMark className="h-8 w-8 transition-transform duration-300 group-hover:-translate-y-0.5" />
        <span className="text-sm font-semibold tracking-[0.28em] text-white">
            SCALEHAUS
        </span>
    </a>
);

export default Logo;
